import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Grid } from '@material-ui/core';

const styles = theme => ({
    paddedGrid: {
        width: '100%'
    },

    padding: {
        padding: theme.spacing.unit * 2,
        margin: 0
    },

    well: {
        margin: theme.spacing.unit * 2,
        padding: theme.spacing.unit * 3,
        backgroundColor: '#eeeeee'
    }
});

const PaddedGrid = (props) => {
    const { children, classes, well } = props;

    return (
        <Grid
            container
            spacing={24}
            alignContent='flex-start'
            alignItems='flex-start'
            className={classes.paddedGrid + ' ' + (props.well ? classes.well : classes.padding)}
        >
            {children}
        </Grid>
    );
};

export default withStyles(styles)(PaddedGrid);



// WEBPACK FOOTER //
// ./resources/assets/js/components/PaddedGrid.js